"use client";
import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

export const proButtonVariants = cva('freeui-btn freeui-no-drag', {
  variants: { size: { sm: 'freeui-btn-sm', md: 'freeui-btn-md', lg: 'freeui-btn-lg' }, active: { true: 'freeui-active', false: '' } },
  defaultVariants: { size: 'sm', active: false }
});
export interface FreeButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof proButtonVariants> {
  ref?: React.Ref<HTMLButtonElement>;
  activeTint?: string;
  backgroundTint?: string;
  plain?: boolean;
  fullWidth?: boolean;
  topHighlightOpacity?: number;
  hoverEffect?: boolean;
}
export function FreeButton({ size, active, activeTint, backgroundTint, plain, fullWidth, topHighlightOpacity = .35, hoverEffect, className, style, ...props }: FreeButtonProps) {
  return <button type="button" aria-pressed={active == null ? undefined : active} data-active={active || undefined} data-plain={plain || undefined}
    className={cn(proButtonVariants({ size, active }), fullWidth && 'w-full', hoverEffect && 'freeui-hover', className)}
    style={{ '--freeui-button-active-tint': activeTint, '--freeui-button-background-tint': backgroundTint, '--freeui-top-highlight-opacity': topHighlightOpacity, ...style } as React.CSSProperties} {...props} />;
}
export function FreeButtonGroup({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div role="group" data-slot="freeui-button-group" className={cn('freeui-button-group freeui-no-drag', className)} {...props} />;
}
